import React from 'react'
import { Icon, Tag, Empty, Card } from 'antd'
import * as _ from 'lodash'

import { ComponentExt } from 'util/reactExt'
import { RouteComponentProps } from 'react-router'
import ListRender from './components/listRender'

import * as styles from './index.scss'

interface IProps extends RouteComponentProps<any> {}
interface IState {}

// 经传人
class Team extends ComponentExt<IProps, IState> {
  state = {
    listType: 0,
    list: [],
    listLen: 0,
    tags: [],
    recommendList: [],
    activityList: [],
    intro: '',
    banner: '',
  }

  async componentDidMount() {
    this.handleRequestList()
  }

  // tslint:disable-next-line: variable-name
  handleRequestList = (params = { label_type: 2 }) => {
    this.handleFetchArticleList(params)
    this.handleFetchHotArticleList(params)
    this.handleFetchLabelList(params)
    this.handleFetchActivityList()
    this.handleFetchActivityIntro()
    this.handleFetchActivityBanner()
  }

  async handleFetchArticleList(params: {
    label_type?: number
    label_id?: number
    type?: number
    page?: number
    limit?: number
  }) {
    try {
      const {
        list,
        count: listLen,
      } = await this.api.family.getFamilyArticleList(params)
      this.setState({
        list,
        listLen,
      })
    } catch (err) {
      console.error(err.message)
    }
  }

  async handleFetchHotArticleList(params: {
    label_type: number
    type?: number
    limit?: number
  }) {
    try {
      const recommendList = await this.api.family.getFamilyHotArticleList(
        params,
      )
      this.setState({
        recommendList,
      })
    } catch (err) {
      console.error(err.message)
    }
  }

  async handleFetchLabelList(params: { label_type: number }) {
    try {
      const tags = await this.api.family.getFamilyLabelList(params)
      this.setState({ tags })
    } catch (err) {
      console.error(err.message)
    }
  }

  async handleFetchActivityList() {
    try {
      const {
        data: activityList,
      } = await this.api.family.getFamilyActivityList({})
      this.setState({ activityList })
    } catch (err) {
      console.error(err.message)
    }
  }

  async handleFetchActivityIntro() {
    try {
      const intro = await this.api.family.getFamilyActivityIntroDuce()
      // console.log('intro', intro)
      this.setState({ intro })
    } catch (err) {
      console.error(err.message)
    }
  }

  async handleFetchActivityBanner() {
    try {
      const banner = await this.api.family.getFamilyActivityBanner()
      // console.log('banner', banner)
      this.setState({
        banner: banner[0],
      })
    } catch (err) {
      console.error(err.message)
    }
  }

  handleSliceString = (str, limit = 30) => {
    let res = str
    if (str && str.length > limit) {
      res = `${str.slice(0, limit)}···`
      return res
    }
    return res
  }

  handleClickMenu = e => {
    let params
    if (e.key === 'news') {
      params = {
        label_type: 2,
      }
      delete params.type
    } else {
      params = {
        label_type: 2,
        type: Number(e.key),
      }
      this.setState({ listType: Number(e.key) })
    }
    this.handleRequestList(params)
  }

  handleClickList = (e, data, type) => {
    // 阻止冒泡
    e.stopPropagation()
    const WINOPEN = url => {
      window.open(window.location.origin + url, '_blank')
    }
    if (type === 'li') {
      WINOPEN(`#/team/detail/${type}?id=${data.id}`)
    } else if (type === 'tag') {
      WINOPEN(
        `#/team/list/${type}?tagName=${data.label_name}&labelId=${data.id}`,
      )
    } else if (type === 'act') {
      WINOPEN(`#/team/actdetail/act?activityId=${data}`)
    } else if (type === 'actBanner') {
      WINOPEN(`#/team/actintro/act?actBanner=${data}`)
    }
  }

  handleCheckTag = data => {
    const { listType } = this.state

    // this.props.history.push(
    //   `team/list/tag?tagName=${data.label_name}&labelId=${data.id}&listType=${listType}`,
    // )
    window.open(
      window.location.origin +
        `#/team/list/tag?tagName=${data.label_name}&labelId=${data.id}&listType=${listType}`,
      '_blank',
    )
  }

  handleRenderList = () => {
    const { list } = this.state
    if (_.isEmpty(list)) {
      return (
        <Card>
          <Empty description="暂无数据" />
        </Card>
      )
    }
    return _.map(list, (itm, idx) => (
      <li
        className={itm.type === '1000101' ? styles.vdBg : null}
        onClick={e => this.handleClickList(e, itm, 'li')}
        key={itm.id}
      >
        <div className={styles.listImg}>
          <img
            src={
              itm.img_url ||
              'http://xy-v.jingzhuan.cn/image/dbcc47bdb414b2bb78ac3727ab565e16.png'
            }
            alt=""
          />
        </div>
        <div className={styles.listContent}>
          <h4>
            {this.handleSliceString(itm.title)}
            {itm.type === '1000101' && <Icon type="play-square" />}
          </h4>
          <p style={{ minHeight: '44px' }}>
            {this.handleSliceString(itm.article_desc, 50)}
          </p>
          <span>{itm.author}</span>
          <span>{itm.publish_date.split(' ')[0]}</span>
          {itm.label.length > 0 &&
            _.map(itm.label, item => (
              <span
                onClick={e => this.handleClickList(e, item, 'tag')}
                key={item.id}
                className={styles.listTag}
              >{`#${item.label_name}`}</span>
            ))}
        </div>
      </li>
    ))
  }

  handleRenderTag = () => {
    const { tags } = this.state
    if (_.isEmpty(tags)) {
      return
    }

    return _.map(tags, itm => (
      <Tag key={itm.id} onClick={() => this.handleCheckTag(itm)}>
        {itm.label_name}
      </Tag>
    ))
  }

  handleRenderRecommend = () => {
    const { recommendList } = this.state
    if (_.isEmpty(recommendList)) {
      return
    }
    return _.map(recommendList, (itm, idx) => {
      if (idx === 0) {
        return (
          <div
            key={itm.id}
            className={styles.banner}
            onClick={e => this.handleClickList(e, itm, 'li')}
          >
            <img src={itm.img_url} alt={itm.article_desc} />
            <p>
              {this.handleSliceString(itm.title)}
              {itm.type === '1000101' && <Icon type="play-square" />}
            </p>
          </div>
        )
      }
      return (
        <li key={itm.id} onClick={e => this.handleClickList(e, itm, 'li')}>
          <p>
            {this.handleSliceString(itm.title)}
            {itm.type === '1000101' && <Icon type="play-square" />}
          </p>
        </li>
      )
    })
  }

  handleRenderActivity = () => {
    const {
      activityList,
      banner,
      intro,
    }: { activityList: any; banner: any; intro: string } = this.state
    const len = activityList.length
    if (_.isEmpty(activityList)) {
      return
    }
    return (
      <>
        <div
          className={styles.banner}
          onClick={e => this.handleClickList(e, intro, 'actBanner')}
        >
          <img
            height="145"
            width="224"
            src={banner.img_url}
            alt={banner.remark}
          />
        </div>
        {_.map(activityList, (itm, idx) => (
          <li key={idx} onClick={e => this.handleClickList(e, itm.id, 'act')}>
            {this.handleSliceString(itm.title)}
          </li>
        ))}
      </>
    )
  }

  render() {
    const that = this
    const {
      state: { list, listLen },
      handleRenderList,
      handleRenderTag,
      handleRenderRecommend,
      handleRenderActivity,
      handleClickMenu,
    } = this
    const mapListRenderProps: any = {
      that,
      listLen,
      handleRenderList,
      handleRenderTag,
      handleRenderRecommend,
      handleClickMenu,
      handleRenderActivity,
    }
    return (
      <div className={styles.team}>
        <div className={styles.topicImg}>
          <img src="https://imgs.n8n8.cn/auto_2019122414563546.jpg" />
        </div>
        <div className={styles.content}>
          <ListRender {...mapListRenderProps} />
        </div>
      </div>
    )
  }
}

export default Team
